import type { PropsWithChildren } from 'react'
import { Navigate } from '@tanstack/react-router'
import { useAuth } from './useAuth'
import { isNativePlatform } from '../../lib/platform'

export function ProtectedLayout({ children }: PropsWithChildren) {
  const { isConfigured, isLoading, user } = useAuth()

  if (!isConfigured) {
    return (
      <section className="configuration-state">
        <p className="eyebrow">Configuration required</p>
        <h1>Connect Supabase to continue</h1>
        <p>Copy <code>.env.example</code> to <code>.env.local</code> and add the project URL and publishable key.</p>
      </section>
    )
  }
  if (isLoading) return <div className="loading-state" role="status">Restoring your secure session…</div>
  if (!user) return <Navigate to={isNativePlatform() ? '/welcome' : '/sign-in'} replace />
  return children
}
